import { inject, Injectable } from '@angular/core';
import { CONFIG_TOKEN } from '@pxl/models/common';
import { UnregisteredDataService } from '@pxl/models/contracts';
import {
    ObjectionStateResult,
    SubmitObjectionResult,
    UnregisteredDataItemModel,
    UnregisteredDataService as GeneratedUnregisteredDataService,
} from '@pxl/shared/generated';
import { Observable } from 'rxjs';

@Injectable()
export class DefaultUnregisteredDataService implements UnregisteredDataService {
    protected readonly unregisteredDataService = inject(GeneratedUnregisteredDataService);
    protected readonly apiVersion = inject(CONFIG_TOKEN).API_VERSION;

    public getUnregisteredDataForEmailLink(linkId: string): Observable<UnregisteredDataItemModel> {
        return this.unregisteredDataService.getUnregisteredDataForEmailLink(linkId, this.apiVersion);
    }

    public getDocument(documentId: string): Observable<string> {
        return this.unregisteredDataService.getDocument(documentId, this.apiVersion);
    }

    public getObjectionState(linkId: string): Observable<ObjectionStateResult> {
        return this.unregisteredDataService.getObjectionState(linkId, this.apiVersion);
    }

    public submitObjection(linkId: string): Observable<SubmitObjectionResult> {
        return this.unregisteredDataService.submitObjection(linkId, this.apiVersion);
    }
}
